import { render, staticRenderFns } from "./PriceCategoryPicker.vue?vue&type=template&id=a115690c"
import script from "./PriceCategoryPicker.vue?vue&type=script&lang=js"
export * from "./PriceCategoryPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports